const instancias = new Map();

class VzSizeGuide extends HTMLElement {
  #abortador = null;
  #datos = null;
  #tocada = false;
  #pid = '';

  connectedCallback() {
    this.#pid = this.dataset.producto || '';
    const previa = instancias.get(this.#pid);
    if (previa && previa !== this && previa.isConnected) {
      this.remove();
      return;
    }
    instancias.set(this.#pid, this);

    const datos = this.querySelector('[data-vzg-datos]');
    this.dlg = this.querySelector('dialog.vzg');
    if (!datos || !this.dlg) return;

    this.#datos = JSON.parse(datos.textContent);
    this.cta = this.dlg.querySelector('.vzg__cta');
    this.vivo = this.querySelector('[data-vzg-vivo]');
    this.#abortador = new AbortController();

    document.body.appendChild(this.dlg);

    this.#wire();
    this.#marcar();
  }

  disconnectedCallback() {
    if (instancias.get(this.#pid) === this) instancias.delete(this.#pid);
    this.#abortador?.abort();
    if (this.dlg) {
      if (this.dlg.open) this.dlg.close();
      this.append(this.dlg);
    }
    document.documentElement.classList.remove('vzg-lock');
  }

  get #signal() {
    return this.#abortador.signal;
  }

  #wire() {
    const { signal } = this;

    this.dlg.addEventListener('close', () => {
      document.documentElement.classList.remove('vzg-lock');
    }, { signal });

    for (const b of this.dlg.querySelectorAll('[data-vzg-cerrar]')) {
      b.addEventListener('click', () => this.#cerrar(), { signal });
    }

    this.dlg.addEventListener('click', (e) => {
      if (e.target === this.dlg) this.#cerrar();
    }, { signal });

    this.dlg.addEventListener('click', (e) => {
      const boton = e.target.closest('[data-vzg-fila]');
      if (!boton) return;
      this.#elegir(boton.dataset.vzgFila);
    }, { signal });

    this.cta.addEventListener('click', () => {
      if (this.cta.getAttribute('aria-disabled') === 'true') {
        this.#anunciar(this.cta.textContent);
        return;
      }
      const co = this.#seleccion();
      if (!co) return;
      this.#track('vz_tabla_tallas_confirmar', { vz_talla: co, vz_origen: this.#tocada ? 'fila' : 'previa' });
      this.dlg.dataset.confirmada = '1';
      this.#cerrar();
    }, { signal });

    document.addEventListener('click', (e) => {
      const l = e.target.closest?.('.vzg-link');
      if (!l) return;
      e.preventDefault();
      this.#abrir('vz_tabla_tallas_link');
    }, { signal });

    document.addEventListener('vz:guia-tallas', (e) => {
      this.#abrir(e?.detail?.origen === 'sticky' ? 'vz_tabla_tallas_sticky' : 'vz_tabla_tallas_link');
    }, { signal });

    const form = this.#formulario();
    form?.addEventListener('change', () => setTimeout(() => this.#marcar(), 60), { signal });

    for (const nombre of ['variant:change', 'variant:changed', 'product:variant-change']) {
      document.addEventListener(nombre, () => setTimeout(() => this.#marcar(), 60), { signal });
    }
  }

  #formulario() {
    return (
      document.querySelector('form.product-form') ||
      document.querySelector('form[action*="/cart/add"]:not(.installment)')
    );
  }

  #radios() {
    return [...document.querySelectorAll('fieldset.product-form__input input[type="radio"]')];
  }

  #seleccion() {
    if (document.documentElement.classList.contains('vz-talla-pendiente')) return null;
    const i = this.#formulario()?.querySelector('[name="id"]');
    return i ? this.#datos.variantes[i.value] : null;
  }

  #radioDe(co) {
    return this.#radios().find((x) => x.value.split(' ')[0] === co) || null;
  }

  #anunciar(mensaje) {
    if (!this.vivo) return;
    this.vivo.textContent = '';
    requestAnimationFrame(() => {
      this.vivo.textContent = mensaje;
    });
  }

  #track(evento, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: evento, vz_producto: this.#datos.titulo, ...extra });
    } catch (e) {}
  }

  #marcar() {
    const co = this.#seleccion();
    const radios = this.#radios();
    let agotada = false;

    for (const tr of this.dlg.querySelectorAll('tr[data-co]')) {
      const sel = tr.dataset.co === co;
      const r = radios.find((x) => x.value.split(' ')[0] === tr.dataset.co);
      const ag = !r || r.classList.contains('disabled') || r.disabled;

      tr.classList.toggle('is-sel', sel);
      tr.classList.toggle('is-agotada', ag);
      if (sel && ag) agotada = true;

      const boton = tr.querySelector('[data-vzg-fila]');
      if (!boton) continue;
      boton.setAttribute('aria-current', sel ? 'true' : 'false');
      if (ag) boton.setAttribute('aria-disabled', 'true');
      else boton.removeAttribute('aria-disabled');
    }

    if (!co) this.#estadoCta(true, 'Toca una talla');
    else if (agotada) this.#estadoCta(true, `Talla ${co} agotada · elige otra`);
    else this.#estadoCta(false, `Elegir talla ${co}`);
  }

  #estadoCta(bloqueada, texto) {
    this.cta.setAttribute('aria-disabled', bloqueada ? 'true' : 'false');
    this.cta.textContent = texto;
  }

  #elegir(co) {
    const tr = this.dlg.querySelector(`tr[data-co="${CSS.escape(co)}"]`);
    if (tr?.classList.contains('is-agotada')) {
      this.#anunciar(`Talla ${co} agotada`);
      return;
    }

    const r = this.#radioDe(co);
    if (r) {
      if (!r.checked) r.click();
      else r.dispatchEvent(new Event('change', { bubbles: true }));
      this.#track('vz_tabla_tallas_fila', { vz_talla: co });
    }
    this.#tocada = true;
    this.#anunciar(`Talla ${co} seleccionada`);
    setTimeout(() => this.#marcar(), 80);
  }

  #abrir(evento) {
    if (this.dlg.open) return;
    this.#tocada = false;
    this.dlg.dataset.confirmada = '';
    this.#marcar();
    this.dlg.showModal();
    document.documentElement.classList.add('vzg-lock');
    this.#track(evento);

    const actual = this.dlg.querySelector('tr.is-sel [data-vzg-fila]');
    const primera = this.dlg.querySelector('[data-vzg-fila]');
    (actual || primera)?.focus();
  }

  #cerrar() {
    if (this.dlg.open) this.dlg.close();
    document.documentElement.classList.remove('vzg-lock');
  }
}

if (!customElements.get('vz-size-guide')) customElements.define('vz-size-guide', VzSizeGuide);
